export default function hasErrors(errors, prefix, ...names) {
  return _.some(names, n => _.has(errors, `${prefix}.${n}`));
}
